import { render, staticRenderFns } from "./CategoryDetailsDistribution.vue?vue&type=template&id=e7bf8772&"
import script from "./CategoryDetailsDistribution.vue?vue&type=script&lang=js&"
export * from "./CategoryDetailsDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports